import { render, staticRenderFns } from "./BizLifeReport.vue?vue&type=template&id=2dd60a13&"
import script from "./BizLifeReport.vue?vue&type=script&lang=js&"
export * from "./BizLifeReport.vue?vue&type=script&lang=js&"
import style0 from "./BizLifeReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports